import attendCode from './attendCode';
export default {
    ...attendCode,
    SHARE: {
        type: 'share',
        code: 'SHARE',
        text: 'common.share',
        color: '#E1BEE7',
        textColor: '#388E3C',
        textColorClass: 'text-orange-darken-2',
    },
};
